var getCookies = require('./dist/cookies').getCookies; // eslint-disable-line no-var,prefer-destructuring

// only export getCookies from this repo
module.exports = {
  getCookies: getCookies, // eslint-disable-line object-shorthand
};
